//slick
$('.type2__inner--2row--item--active').slick({
    infinite: true,
    fade: true,
    arrows: true,
    prevArrow: '<div class="slick__left"></div>',
	nextArrow: '<div class="slick__right"></div>',
});
$('.type2__inner--2row--item--inactive').slick({
    infinite: true,
    slidesToShow: 20,
    focusOnSelect: true,
    asNavFor: '.type2__inner--2row--item--active',
});
$('.type2__inner--2row--item--active').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var index = nextSlide;
    $(".type2__inner--2row--item--inactive .slick-slide").removeClass("slick-current").eq(index).addClass("slick-current");
});

//slick
$('.service__media .mediamenu__content').slick({
    infinite: true,
    fade: true,
    arrows: true,
    prevArrow: '<div class="slick__left"></div>',
    nextArrow: '<div class="slick__right"></div>',
});
$('.service__media .mediamenu__list').slick({
    infinite: true,
    slidesToShow: 20,
    focusOnSelect: true,
    asNavFor: '.service__media .mediamenu__content',
});
$('.service__media .mediamenu__content').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var index = nextSlide;
    $(".service__media .mediamenu__list .slick-slide").removeClass("slick-current").eq(index).addClass("slick-current");
});

//slick
$('.service__social_media .social_mediamenu__content').slick({
    infinite: true,
    fade: true,
    arrows: false,
});
$('.service__social_media .social_mediamenu__list').slick({
    infinite: true,
    slidesToShow: 20,
    focusOnSelect: true,
    asNavFor: '.service__social_media .social_mediamenu__content',
});
$('.service__social_media .social_mediamenu__content').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var index = nextSlide;
    $(".service__social_media .social_mediamenu__list .slick-slide").removeClass("slick-current").eq(index).addClass("slick-current");
});